import React from 'react';

const CancelCheckout = () => {
  return (
    <div>
      <h1>Checkout Canceled</h1>
      <p>Your checkout was canceled.</p>
      {/* You can add additional content or links here */}
    </div>
  );
};

export default CancelCheckout;